import WebRequest from "./client/WebRequest.js";
import { MutationKeys } from "./service.js";
import { queryString } from "./query-string.js";
export var CreateGeneralConsultationRequest;
(function (CreateGeneralConsultationRequest) {
    function api(data) {
        return WebRequest.POST("/general-consultations").body(data);
    }
    function mutation(client) {
        return {
            mutationFn: (data) => client.execute(api(data)),
            mutationKey: MutationKeys.RequestGeneralConsultation(),
        };
    }
    CreateGeneralConsultationRequest.mutation = mutation;
})(CreateGeneralConsultationRequest || (CreateGeneralConsultationRequest = {}));
export var RequestGeneralConsultationMobilePayment;
(function (RequestGeneralConsultationMobilePayment) {
    function api({ request, consultationId, rewardId }) {
        const search = queryString({ consultationId, rewardId }, { skipNulls: true });
        return WebRequest.POST(search
            ? `/general-consultations/mobile-payment?${search}`
            : "/general-consultations/mobile-payment").body(request);
    }
    RequestGeneralConsultationMobilePayment.api = api;
    function mutation(client) {
        return {
            mutationFn: (params) => client.execute(api(params)),
            mutationKey: MutationKeys.RequestGeneralConsultationMobilePayment(),
        };
    }
    RequestGeneralConsultationMobilePayment.mutation = mutation;
})(RequestGeneralConsultationMobilePayment || (RequestGeneralConsultationMobilePayment = {}));
export var IssueOrUpdateMedicalCertificate;
(function (IssueOrUpdateMedicalCertificate) {
    function api({ reference, data }) {
        return WebRequest.POST(`/doctor/consultations/${reference}/issuance/medical-certificate`).body(data);
    }
    function mutation(client, reference) {
        return {
            mutationFn: (data) => client.executeEmpty(api({ reference, data })),
            mutationKey: MutationKeys.IssueOrUpdateMedicalCertificate(reference),
        };
    }
    IssueOrUpdateMedicalCertificate.mutation = mutation;
})(IssueOrUpdateMedicalCertificate || (IssueOrUpdateMedicalCertificate = {}));
export var DeleteMedicalCertificate;
(function (DeleteMedicalCertificate) {
    function api(reference) {
        return WebRequest.POST(`/doctor/consultations/${reference}/issuance/medical-certificate/delete`);
    }
    function mutation(client, reference) {
        return {
            mutationFn: () => client.executeEmpty(api(reference)),
            mutationKey: MutationKeys.DeleteMedicalCertificate(reference),
        };
    }
    DeleteMedicalCertificate.mutation = mutation;
})(DeleteMedicalCertificate || (DeleteMedicalCertificate = {}));
export var DeleteGeneralLetter;
(function (DeleteGeneralLetter) {
    function api(id, reference) {
        return WebRequest.POST(`/doctor/consultations/${reference}/issuance/general-letter/delete?id=${id}`);
    }
    function mutation(client, reference) {
        return {
            mutationFn: (id) => client.executeEmpty(api(id, reference)),
            mutationKey: MutationKeys.DeleteGeneralLetter(reference),
        };
    }
    DeleteGeneralLetter.mutation = mutation;
})(DeleteGeneralLetter || (DeleteGeneralLetter = {}));
export var IssueOrUpdateSpecialistReferral;
(function (IssueOrUpdateSpecialistReferral) {
    function api({ reference, data }) {
        return WebRequest.POST(`/doctor/consultations/${reference}/issuance/specialist-referral`).body(data);
    }
    function mutation(client, reference) {
        return {
            mutationFn: (data) => client.executeEmpty(api({ reference, data })),
            mutationKey: MutationKeys.IssueOrUpdateSpecialistReferral(reference),
        };
    }
    IssueOrUpdateSpecialistReferral.mutation = mutation;
})(IssueOrUpdateSpecialistReferral || (IssueOrUpdateSpecialistReferral = {}));
export var DeleteSpecialistReferral;
(function (DeleteSpecialistReferral) {
    function api(reference) {
        return WebRequest.POST(`/doctor/consultations/${reference}/issuance/specialist-referral/delete`);
    }
    function mutation(client, reference) {
        return {
            mutationFn: () => client.executeEmpty(api(reference)),
            mutationKey: MutationKeys.DeleteSpecialistReferral(reference),
        };
    }
    DeleteSpecialistReferral.mutation = mutation;
})(DeleteSpecialistReferral || (DeleteSpecialistReferral = {}));
export var IssueOrUpdatePathologyReferral;
(function (IssueOrUpdatePathologyReferral) {
    function api({ reference, data }) {
        return WebRequest.POST(`/doctor/consultations/${reference}/issuance/pathology-referral`).body(data);
    }
    function mutation(client, reference) {
        return {
            mutationFn: (data) => client.executeEmpty(api({ reference, data })),
            mutationKey: MutationKeys.IssueOrUpdatePathologyReferral(reference),
        };
    }
    IssueOrUpdatePathologyReferral.mutation = mutation;
})(IssueOrUpdatePathologyReferral || (IssueOrUpdatePathologyReferral = {}));
export var IssueOrUpdateRadiologyReferral;
(function (IssueOrUpdateRadiologyReferral) {
    function api({ reference, data }) {
        return WebRequest.POST(`/doctor/consultations/${reference}/issuance/radiology-referral`).body(data);
    }
    function mutation(client, reference) {
        return {
            mutationFn: (data) => client.executeEmpty(api({ reference, data })),
            mutationKey: MutationKeys.IssueOrUpdateRadiologyReferral(reference),
        };
    }
    IssueOrUpdateRadiologyReferral.mutation = mutation;
})(IssueOrUpdateRadiologyReferral || (IssueOrUpdateRadiologyReferral = {}));
export var IssueOrUpdateGeneralLetter;
(function (IssueOrUpdateGeneralLetter) {
    function api({ reference, data }) {
        return WebRequest.POST(`/doctor/consultations/${reference}/issuance/general-letter`).body(data);
    }
    function mutation(client, reference) {
        return {
            mutationFn: (data) => client.executeEmpty(api({ reference, data })),
            mutationKey: MutationKeys.IssueOrUpdateGeneralLetter(reference),
        };
    }
    IssueOrUpdateGeneralLetter.mutation = mutation;
})(IssueOrUpdateGeneralLetter || (IssueOrUpdateGeneralLetter = {}));
export var SpecialistReferralDownload;
(function (SpecialistReferralDownload) {
    function api({ reference }) {
        return WebRequest.GET(`/doctor/consultations/${reference}/issuance/specialist-referral/download`);
    }
    SpecialistReferralDownload.api = api;
    function mutation(client) {
        return {
            mutationFn: async (reference) => await client.execute(api({ reference })),
        };
    }
    SpecialistReferralDownload.mutation = mutation;
})(SpecialistReferralDownload || (SpecialistReferralDownload = {}));
export var PathologyReferralDownload;
(function (PathologyReferralDownload) {
    function api({ reference, id }) {
        const search = queryString({ id }, { skipNulls: true });
        return WebRequest.GET(`/doctor/consultations/${reference}/issuance/pathology-referral/download${search ? `?${search}` : ""}`);
    }
    PathologyReferralDownload.api = api;
    function mutation(client) {
        return {
            mutationFn: async (params) => await client.execute(api(params)),
        };
    }
    PathologyReferralDownload.mutation = mutation;
})(PathologyReferralDownload || (PathologyReferralDownload = {}));
export var RadiologyReferralDownload;
(function (RadiologyReferralDownload) {
    function api({ reference, id }) {
        const search = queryString({ id }, { skipNulls: true });
        return WebRequest.GET(`/doctor/consultations/${reference}/issuance/radiology-referral/download${search ? `?${search}` : ""}`);
    }
    RadiologyReferralDownload.api = api;
    function mutation(client) {
        return {
            mutationFn: async (params) => await client.execute(api(params)),
        };
    }
    RadiologyReferralDownload.mutation = mutation;
})(RadiologyReferralDownload || (RadiologyReferralDownload = {}));
export var GeneralLetterDownload;
(function (GeneralLetterDownload) {
    function api({ reference, id }) {
        return WebRequest.GET(`/doctor/consultations/${reference}/issuance/general-letter/download?id=${id}`);
    }
    GeneralLetterDownload.api = api;
    function mutation(client) {
        return {
            mutationFn: async (params) => await client.execute(api(params)),
        };
    }
    GeneralLetterDownload.mutation = mutation;
})(GeneralLetterDownload || (GeneralLetterDownload = {}));
export var RejectGeneralConsultation;
(function (RejectGeneralConsultation) {
    async function api(client, { request, reference }) {
        const req = WebRequest.POST(`/doctor/consultations/${reference}/reject`).body(request);
        return client.executeEmpty(req);
    }
    function mutation(client, params) {
        const { reference } = params;
        return {
            mutationFn: (request) => api(client, { ...params, request }),
            mutationKey: ["reject-general-consultation", reference],
        };
    }
    RejectGeneralConsultation.mutation = mutation;
})(RejectGeneralConsultation || (RejectGeneralConsultation = {}));
export var ApproveGeneralConsultation;
(function (ApproveGeneralConsultation) {
    async function api(client, { request, reference }) {
        const req = WebRequest.POST(`/doctor/consultations/${reference}/approve`).body(request);
        return client.executeEmpty(req);
    }
    function mutation(client, params) {
        const { reference } = params;
        return {
            mutationFn: (request) => api(client, { ...params, request }),
            mutationKey: ["approve-general-consultation", reference],
        };
    }
    ApproveGeneralConsultation.mutation = mutation;
})(ApproveGeneralConsultation || (ApproveGeneralConsultation = {}));
export var VerifyGeneralLetter;
(function (VerifyGeneralLetter) {
    async function api(client, { id, signature }) {
        const url = `/general-letters/verify`;
        const search = queryString({ id, signature });
        return client.execute(WebRequest.GET(`${url}?${search}`));
    }
    VerifyGeneralLetter.api = api;
})(VerifyGeneralLetter || (VerifyGeneralLetter = {}));
export var VerifyPathologyReferral;
(function (VerifyPathologyReferral) {
    async function api(client, { reference, signature }) {
        const url = `/pathology-referrals/${reference}/verify`;
        const search = queryString({ signature });
        return client.execute(WebRequest.GET(`${url}?${search}`));
    }
    VerifyPathologyReferral.api = api;
})(VerifyPathologyReferral || (VerifyPathologyReferral = {}));
export var VerifyRadiologyReferral;
(function (VerifyRadiologyReferral) {
    async function api(client, { reference, signature }) {
        const url = `/radiology-referrals/${reference}/verify`;
        const search = queryString({ signature });
        return client.execute(WebRequest.GET(`${url}?${search}`));
    }
    VerifyRadiologyReferral.api = api;
})(VerifyRadiologyReferral || (VerifyRadiologyReferral = {}));
